<template>
  <div v-if="(attributes||[]).length > 0" class="attribute-table">
    <h2 v-if="title" class="subtitle">{{ title }}</h2>
    <table class="table is-striped is-fullwidth">
      <tbody>
        <slot name="pre"/>
        <tr v-for="a in attributes" :key="a.key">
          <th width="50%">
            <b-checkbox v-if="selectable" :disabled="excludedKeys.includes(a.key)" :value="value" @input="e => $emit('input', e)" :native-value="a.key"/>
            <slot :name="`key-${a.key}`" v-bind="a">{{ a.key }}</slot>
          </th>
          <td width="50%">
            <slot :name="`value-${a.key}`" v-bind="a">{{ a.value }}</slot>
          </td>
        </tr>
        <slot name="post"/>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  emits: ['input'],
  props: {
    title: String,
    attributes: Array,
    value: Array,
    selectable: Boolean
  },
  computed: {
    excludedKeys () { return ['groups'] }
  }
}
</script>